import { FormControlLabel } from "@mui/material";
import Delete from "@src/icons/Delete";
import styled from "styled-components";

export const StyledFormControlLabel = styled(FormControlLabel)`
    && {
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const DeleteCodeButtonIcon = styled(Delete)`
    && {
        width: 12px;
        height: 12px;
        margin-right: 5px;
    }
`;

export const FormButtonsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: ${({ theme }) => theme.spacing(2)};
`;
